<template>
  <div class="content"> 
    <div class="content-view">
      <!-- <keep-alive :include="keepAliveArr"> -->
        <transition name="fade-transform" mode="out-in">
          <router-view class="content"></router-view>
        </transition>
      <!-- </keep-alive> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isRouterAlive: true,  // KeepAlive
    };
  },
  created() {
    // 刷新后回到首页
    // if(this.editableTabs.length == 1) {
    //   this.$router.replace('/home');
    // }
  },
  computed: {
    keepAliveArr() {
      return this.$store.state.keepAliveArr;
    },
  },
  mounted() {},
  methods: {
  },
};
</script>

<style lang="scss">
.content {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  
  .content-view {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 15px;
  }
}

// 路由过渡动画
.fade-transform-enter-active,
.fade-transform-leave-active {
  transition: all 0.3s ease;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}
</style>
